import { CLOUDINARY_INTEL_BASE_URL } from "../../../../utils/enum";
import styles from "./ProfilHeaderPill.module.scss";

const ProfileHeaderPill = ({ profileType, label, value, backgroundColor, handleCopy, isCopy }) => {
  return value ? (
    <div
      className={`${styles.profileHeaderPill} ${profileType === "company" ? "!tw-mr-0" : ""}`}
      style={{
        backgroundColor: backgroundColor ?? "",
      }}>
      <span>
        {label}: <span className={styles.profileHeaderPillValue}>{value}</span>
      </span>
      {/* Copy Icon */}
      {isCopy && <img src={`${CLOUDINARY_INTEL_BASE_URL}/v1709185641/intel/icons/hdg1qqouwpmldojxnmwh.svg`} className={styles.copyImg} onClick={() => handleCopy(value)} />}
    </div>
  ) : null;
};

export default ProfileHeaderPill;
